import { toast } from '@webapp/components/Notification'
import { type FeatureExpansionRequestType } from '@webapp/core/services/Marketo'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useMutateTakeProductTour } from '../../models'
import { buildProductTourUrl } from '../../utils'

interface IUseTakeProductTourButtonPresenterProps {
  context: FeatureExpansionRequestType
  title?: string
  onTourOpened?: () => void
}

export const useTakeProductTourButtonPresenter = ({
  context,
  title,
  onTourOpened,
}: IUseTakeProductTourButtonPresenterProps) => {
  const intl = useProcurifyIntl()

  const { mutateAsync, isLoading } = useMutateTakeProductTour()

  const tourUrl = buildProductTourUrl(context)

  const openTour = async () => {
    if (!tourUrl) {
      return
    }

    onTourOpened?.()

    try {
      await mutateAsync({
        url: tourUrl,
        title: title ?? intl.formatMessage(messages.popupTitle),
      })
    } catch {
      toast.error({
        title: intl.formatMessage(messages.errorTitle),
        children: intl.formatMessage(messages.errorMessage),
      })
    }
  }

  return {
    data: {
      tourUrl,
    },
    states: {
      isOpening: isLoading,
    },
    commands: {
      openTour,
    },
  }
}
